
import React from 'react';
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { commonTimezones, getTimezoneDisplayName } from '@/utils/timeZoneUtils';
import { Globe } from 'lucide-react';

interface TimezoneSelectorProps {
  timezone: string;
  setTimezone: (timezone: string) => void;
  className?: string;
}

const TimezoneSelector: React.FC<TimezoneSelectorProps> = ({ 
  timezone, 
  setTimezone,
  className
}) => {
  return (
    <div className={className}>
      <label className="block text-sm font-medium mb-2 flex items-center">
        <Globe className="mr-2 h-4 w-4 text-primary" />
        Timezone
      </label>
      <Select
        value={timezone}
        onValueChange={setTimezone}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select timezone" />
        </SelectTrigger>
        <SelectContent className="max-h-[300px]">
          {commonTimezones.map((tz) => (
            <SelectItem key={tz} value={tz}>
              {getTimezoneDisplayName(tz)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-xs text-muted-foreground mt-1">
        All times will be displayed in your selected timezone
      </p>
    </div>
  );
};

export default TimezoneSelector;
